<template>
	<div class="introduce">
		<Header></Header>
		<div class="introduce_main_box">
			<p align="center" style="text-align: center; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style="vertical-align:baseline"
							><span style="font-family:Calibri"
								><b
									><span style="font-size:18.0000pt"
										><span style="font-family:黑体"
											><span style="font-weight:bold"
												>30&middot;60双碳战略研究与决策支撑平台</span
											></span
										></span
									></b
								></span
							></span
						></span
					></span
				>
			</p>

			<p align="right" style="text-align: right; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style="vertical-align:baseline"
							><span style="font-family:Calibri"
								><b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style="font-weight:bold"
												>----绿色未来&middot;从碳启航</span
											></span
										></span
									></b
								></span
							></span
						></span
					></span
				>
			</p>

			<h1
				style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify"
			>
				<span style="font-size:22pt"
					><span style="vertical-align:baseline"
						><span style=""
							><span style="font-family:Calibri"
								><span style="font-weight:bold"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:Calibri"
												><span style="font-weight:bold"
													><font face="宋体"
														>一、平台介绍</font
													></span
												></span
											></span
										></b
									></span
								></span
							></span
						></span
					></span
				>
			</h1>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>&ldquo;30&middot;60双碳战略研究与决策支撑平台&rdquo;（以下简称&ldquo;平台&rdquo;）是国研网精心设计打造的一站式综合性双碳信息服务平台</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>，</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>旨在通过及时全面跟踪双碳领域政策动向、实践趋势、学术前沿、典型案例、多维数据等，为有关党政机关、科研院所、企业单位在双碳领域的深入研究与科学决策提供有力支撑，赋能各方聚焦双碳</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>战略</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>目标，共创绿色发展未来。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<h1
				style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify"
			>
				<span style="font-size:22pt"
					><span style="vertical-align:baseline"
						><span style=""
							><span style="font-family:Calibri"
								><span style="font-weight:bold"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:Calibri"
												><span style="font-weight:bold"
													><font face="宋体"
														>二、十大板块</font
													></span
												></span
											></span
										></b
									></span
								></span
							></span
						></span
					></span
				>
			</h1>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>平台</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>以</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>用户需求</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>为导向</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>，推出政策、资讯、报告、论文、案例、数据和专题等专项服务内容，设有权威声音、政策规划、动态资讯、专家评论、学术论文、研究报告、典型案例、双碳实践、统计数据、特色专题十大板块。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>
			<img
				src="../../assets/homeContent/homeImgJt.png"
				style="max-width: 100%;"
				alt=""
			/>

			<p
				align="center"
				style="text-align: center; text-indent: 2em; margin: 0px !important;"
			>
				&nbsp;
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>&mdash;&mdash;权威声音：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>收录国家领导人关于实现碳达峰、碳中和工作的重要指示以及各省部级领导关于碳达峰、碳中和的讲话，为用户科学制定双碳政策，有效谋划双碳目标实现路径，深入开展碳减排工作提供指引。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>&mdash;&mdash;政策规划：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>动态跟踪全国人大常委会、国务院、各部委以及各级地方政府关于双碳的政策规划、战略部署，满足用户关于政策动向的信息需求，并对政策法规按区域进行分类，便于用户开展地区政策跟踪、对比等工作</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>&mdash;&mdash;动态资讯：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>精选气候生态、碳排放、碳市场、碳金融、碳汇、碳税等领域重要资讯，覆盖全球各国及国内省区市，并深入聚焦</font
												>14个重点行业。栏目时效性强，内容丰富度高，能够确保用户及时获取全面准确的信息资讯。</span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>&mdash;&mdash;专家评论：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>收录知名学者、行业专家对双碳领域热点话题、政策变化以及发展趋势的独到见解，为用户开展研究和决策工作启发新思路、拓展新视野、提供新方法。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>&mdash;&mdash;学术论文：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>聚焦双碳目标、可持续发展与循环经济，收录高质量的学术论文，并根据热门领域、重点学科、主要行业进行标签分类，为高校或机构研究人员提供丰富的学术资源。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>&mdash;&mdash;</font
												></span
											></span
										></span
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><span
														style="font-weight:bold"
														><font face="宋体"
															>研究报告</font
														></span
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>：自研报告收录国研网专业研究团队自主撰写的行业周评和热点报告；智库报告收录国研网自主编译以及精选的全球头部智库中英文报告，帮助用户深入理解双碳领域重要政策内容，客观洞察行业重点热点问题及时获取前沿理论成果。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>&mdash;&mdash;典型案例：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>精选国内外成功或具有启示意义的低碳发展实践案例，深入分析其成功经验、问题挑战及解决策略，为政府决策和企业转型提供参考。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>&mdash;&mdash;双碳实践：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>跟踪各地碳达峰实施方案，锚定方案重要任务，以可视化图表等方式，展示绿色转型、节能减排等方面的目标和成效，便于用户直观对比分析各地在双碳领域的实践探索情况。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>&mdash;&mdash;统计数据：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>关注双碳领域重要数据，收录能源领域、碳排放、碳交易以及碳金融产品</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>四大方面数据，</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>时间长度上跨越</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												>20余年，地域上不仅覆盖全球、全国、各省的数据，还下沉</span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>到了</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>主要城市、主要区县</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>，涉及超过</font
												>3万个数据指标，数据年更新量在6万条以上。主要数据指标以可视化方式呈现，支持在线查询、下载，为用户<font
													face="宋体"
													>有关分析研究提供数据支撑。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>&mdash;&mdash;特色专题：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>收录双碳领域当月热点焦点议题以及绿色金融、</font
												>ESG等热门领域的动态资讯、专家评论和研究成果，及时反映热点领域的前沿进展和发展趋势，为用户提供高附加值的参考信息。</span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<h1
				style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify"
			>
				<span style="font-size:22pt"
					><span style="vertical-align:baseline"
						><span style=""
							><span style="font-family:Calibri"
								><span style="font-weight:bold"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:Calibri"
												><span style="font-weight:bold"
													><font face="宋体"
														>三、平台优势</font
													></span
												></span
											></span
										></b
									></span
								></span
							></span
						></span
					></span
				>
			</h1>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>双碳平台由国研网依托丰富的信息资源、先进的技术手段和多年的产品经验精心设计打造，具有视野高端、分类清晰、内容优质、展示直观以及功能丰富五大优势。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: justify; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>全局视野，内容前沿。</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>站在国内外全局视角</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>，</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>在广泛收录中国在双碳领域有关实践探索和理论研究信息基础上，重点收录美国、英国、德国、法国、日本等在双碳领域的政策文件、实践信息、经验借鉴、数据等信息，便于用户以更广阔的视野观察和研究双碳问题。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>分类多维，科学清晰。</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>平台涵盖政策、资讯、报告、论文、案例、数据、专题等十大维度，每个维度下又细分为不同栏目，部分栏目还设置了国家、地区和行业分类标签，便于不同用户快速获取重点关注信息。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>特色报告，优质权威。</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>平台围绕双碳领域，提供国研网研究团队自主撰写的行业周评以及深度研究报告，并提供自主编译</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>和精选</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>的众多世界</font
												>/区域性权威组织及国际高端智库的</span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>中英文</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>研究报告，帮助用户获取高附加值的参考信息，提高双碳理论研究、政策制定的科学性和有效性。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>可视挖掘，直观洞察</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>。数据方面，构建多维立体的数据库，系统地整合了双碳研究及决策所需重点数据，并提供数据的可视化分析展示，深入挖掘数据背后的关联性和规律性；资讯方面，地方实践板块创新性地通过可视化方式，跟踪地方碳达峰实施方案目标及推进情况，能够帮助用户更准确地把握趋势、发现问题并科学决策。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>功能丰富，智慧人性。</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>平台注重用户体验，界面设计简洁大方，操作流程友好直观，通过利用人工智能、可视化等前沿信息技术，实现了关键字浏览、标签分类、数据查询、报告下载等丰富功能，真正做到资源、应用、服务多层面的集成和整合。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<h1
				style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify"
			>
				<span style="font-size:22pt"
					><span style="vertical-align:baseline"
						><span style=""
							><span style="font-family:Calibri"
								><span style="font-weight:bold"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:Calibri"
												><span style="font-weight:bold"
													><font face="宋体"
														>四、平台价值</font
													></span
												></span
											></span
										></b
									></span
								></span
							></span
						></span
					></span
				>
			</h1>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>一站式洞察双碳领域全景：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>平台及时有效地汇聚了双碳领域从动态资讯到深度研究、从政策解读到实践案例、从实施方案到发展数据等的全方位内容，用户无需跳转多个平台，即可快速在一个界面下全面洞悉双碳领域的政策动向、前沿动态与发展趋势。这种一站式的设计极大提升了信息获取的效率与广度，有助于用户快速把握市场脉搏，抢占先机。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>政策跟踪与决策支持：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>平台汇集了国内外重要政策及政策解读，能够为有关政府机构、高校院所以及重要企业提供及时的政策跟踪服务，帮助用户在研究、决策过程中准确把握双碳领域政策导向。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>知识共享与学术交流：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>平台精选丰富的资讯，收录前沿的论文，提供自主撰写的深度报告，并汇集多维度数据，为研究人员提供宝贵的学术参考和研究支撑，促进跨领域的知识交流与融合，共同推动双碳领域学科发展和人才</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>队伍</font
												></span
											></span
										></span
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>建设。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>推动双碳实践与绿色发展：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>平台以全球视野追踪国内外双碳实践的探索工作，推广优秀案例，助力绿色发展。同时，平台还为相关企业提供绿色技术、节能减排等信息支持，助力企业实现可持续发展目标。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<h1
				style="margin-top:17pt; margin-bottom:16.5pt; text-align:justify"
			>
				<span style="font-size:22pt"
					><span style="vertical-align:baseline"
						><span style=""
							><span style="font-family:Calibri"
								><span style="font-weight:bold"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:Calibri"
												><span style="font-weight:bold"
													><font face="宋体"
														>五、服务方式</font
													></span
												></span
											></span
										></b
									></span
								></span
							></span
						></span
					></span
				>
			</h1>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>平台订阅：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>用户可直接订阅国研网双碳平台，用以获取高质量信息支撑双碳方面的研究及决策。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>信息定制：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>依托双碳平台，国研网能提供信息定制、课题咨询、指数编制等多项与双碳相关的多样化增值服务，为用户进行战略规划、政策制定、管理优化等提供高端决策参考。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left; text-indent: 2em;">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="vertical-align:baseline"
								><span style="font-family:Calibri"
									><b
										><span style="font-size:15.0000pt"
											><span style="font-family:宋体"
												><span style=""
													><font face="宋体"
														>平台定制：</font
													></span
												></span
											></span
										></b
									><span style="font-size:15.0000pt"
										><span style="font-family:宋体"
											><span style=""
												><font face="宋体"
													>国研网拥有一支技术精湛的研发队伍，具备敏捷的开发能力，能够依据不同用户的个性化需求提供定制化信息平台开发服务，满足用户对双碳信息平台的开发需要。</font
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>

			<p style="text-align: left;margin:20px 0">
				<span style="font-size:10.5pt"
					><span style="background:#ffffff"
						><span style=""
							><span style="font-family:Calibri"
								><b
									><span
										class="15"
										style="font-size:12.0000pt"
										><span style="background:#ffffff"
											><span style="font-family:微软雅黑"
												><span style=""
													><span style="color:#202223"
														><span
															style="letter-spacing:0.0000pt"
															><span
																style="font-weight:bold"
																><span
																	style="text-transform:none"
																	><span
																		style="font-style:normal"
																		><font
																			face="微软雅黑"
																			>北京国研网信息股份有限公司</font
																		></span
																	></span
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									></b
								><br />
								<span style="font-size:12.0000pt"
									><span style="background:#ffffff"
										><span style="font-family:微软雅黑"
											><span style=""
												><span style="color:#202223"
													><span
														style="letter-spacing:0.0000pt"
														><span
															style="text-transform:none"
															><span
																style="font-style:normal"
																><font
																	face="微软雅黑"
																	>公司地址：北京市东城区美术馆后街</font
																><font
																	face="微软雅黑"
																	>77文创园2号楼201</font
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									></span
								><br />
								<span style="font-size:12.0000pt"
									><span style="background:#ffffff"
										><span style="font-family:微软雅黑"
											><span style=""
												><span style="color:#202223"
													><span
														style="letter-spacing:0.0000pt"
														><span
															style="text-transform:none"
															><span
																style="font-style:normal"
																><font
																	face="微软雅黑"
																	>联系电话：</font
																><font
																	face="微软雅黑"
																	>010-85112336</font
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									></span
								><br />
								<span style="font-size:12.0000pt"
									><span style="background:#ffffff"
										><span style="font-family:微软雅黑"
											><span style=""
												><span style="color:#202223"
													><span
														style="letter-spacing:0.0000pt"
														><span
															style="text-transform:none"
															><span
																style="font-style:normal"
																><font
																	face="微软雅黑"
																	>服务热线：</font
																><font
																	face="微软雅黑"
																	>400-707-0678</font
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									></span
								><br />
								<span style="font-size:12.0000pt"
									><span style="background:#ffffff"
										><span style="font-family:微软雅黑"
											><span style=""
												><span style="color:#202223"
													><span
														style="letter-spacing:0.0000pt"
														><span
															style="text-transform:none"
															><span
																style="font-style:normal"
																><font
																	face="微软雅黑"
																	>电子信箱：</font
																><font
																	face="微软雅黑"
																	>service@drcnet.com.cn</font
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									></span
								><br />
								<span style="font-size:12.0000pt"
									><span style="background:#ffffff"
										><span style="font-family:微软雅黑"
											><span style=""
												><span style="color:#202223"
													><span
														style="letter-spacing:0.0000pt"
														><span
															style="text-transform:none"
															><span
																style="font-style:normal"
																><font
																	face="微软雅黑"
																	>网址：</font
																><font
																	face="微软雅黑"
																	>http://carbon.drcnet.com.cn</font
																></span
															></span
														></span
													></span
												></span
											></span
										></span
									></span
								></span
							></span
						></span
					></span
				>
			</p>
			<br />
			<div style="width:100%;text-align:left;">
				<div
					style="display:inline-block;width:200px;height:300px;margin-right:40px;"
				>
					<img
						style="display:inline-block;width:100%;border:1px solid #ccc;"
						src="../../assets/main/info8.jpg"
						alt=""
					/>
					<p style="width:100%;text-align:center;">服务号</p>
				</div>
				<div
					style="display:inline-block;width:200px;height:300px;margin-right:40px;"
				>
					<img
						style="display:inline-block;width:100%;border:1px solid #ccc;"
						src="../../assets/main/info9.jpg"
						alt=""
					/>
					<p style="width:100%;text-align:center;">订阅号</p>
				</div>
				<div style="display:inline-block;width:200px;height:300px;">
					<img
						style="display:inline-block;width:100%;border:1px solid #ccc;"
						src="../../assets/main/info10.png"
						alt=""
					/>
					<p style="width:100%;text-align:center;">安卓版</p>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';

import Header from '@/components/header';
import Footer from '@/components/footer';

export default {
	props: {},
	components: {
		Header,
		Footer,
	},
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() {},
	mounted() {},
};
</script>
<style scoped lang="less">
.introduce {
	width: 100%;
	// height: 100%;
	background: #f2f2f2;
}
.introduce_main_box {
	width: 1100px;
	margin: 54px auto 0;
	min-height: 600px;
	background: #fff;
	padding: 50px;
}
.introduce_main_box p {
	font-size: 16px;
	line-height: 2.5;
	// margin-bottom:70px;
	color: #202223;
	font-family: '微软雅黑', 'Heiti SC', '黑体', 'Arial';
}
.introduce_main_box h5 {
	width: 100%;
	text-align: center;
	font-size: 30px;
	font-weight: bold;
	margin: 60px 0 30px;
}
.introduce_main_box strong {
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/introduce/index.vue